'use client';

import { ErrorOverlay } from '@/app/components/ErrorOverlay';

import { useEffect } from 'react';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

/**
 * Página de error global para manejar errores del servidor.
 * Utiliza el componente NotificationMessage centrado en la pantalla.
 */
export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    console.error('Application error:', error);
  }, [error]);

  const handleRetry = () => {
    try {
      reset();
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch {
      window.location.reload();
    }
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return <ErrorOverlay primaryCallback={handleRetry} secondaryCallback={handleGoBack} />;
}
